// extracted by mini-css-extract-plugin
module.exports = {"socialDiv":"styles_socialDiv__38tcD","socialIcons":"styles_socialIcons__unWAN"};